import { gql } from '@apollo/client';

export const SCORING_CATEGORY_DELETED = gql`
  subscription scoringCategoryDeleted {
    scoringCategoryDeleted {
      scoringId
    }
  }
`;
